<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/niEgY5/tc-custom/9781627794541.jpg?1719374954973" alt="This image is the cover for the book Absalom's Daughters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Absalom's Daughters
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A spellbinding debut about half sisters, one black and one white, on a 1950s road trip through the American South</b><br/><br/>Self-educated and brown-skinned, Cassie works full time in her grandmother’s laundry in rural Mississippi. Illiterate and white, Judith falls for “colored music” and dreams of life as a big city radio star. These teenaged girls are half-sisters. And when they catch wind of their wayward father’s inheritance coming down in Virginia, they hitch their hopes to a road trip together to claim what’s rightly theirs.<br/><br/> In an old junk car, with a frying pan, a ham, and a few dollars hidden in a shoe, they set off through the American Deep South of the 1950s, a bewitchingly beautiful landscape as well as one bedeviled by racial strife and violence. Suzanne Feldman's<i> Absalom’s Daughters</i> combines the buddy movie, the coming-of-age tale, and a dash of magical realism to enthrall and move us with an unforgettable, illuminating novel.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Suzanne Feldman
      </h2>
      
      <p class="authorDescription body article"><B>Suzanne Feldman</B>, a recipient of the <I>Missouri Review</I> Jeffrey E. Smith Editors' Prize and a finalist for the Bakeless Prize in fiction, holds an MA in fiction from Johns Hopkins University and a BFA in art from the Maryland Institute College of Art. She is the author of award-winning science fiction titles like <I>Speaking Dreams</I> and <I>The Annunciate</I>, published under the pen name Severna Park. Her short fiction has appeared in <I>Narrative</I>, <I>The Missouri Review</I>, <I>Gargoyle</I>, and other literary journals. She lives in Frederick, Maryland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43ccd5ba